import * as React from 'react';

import { DangerousHtml } from '../DangerousHtml';
import { getCloudinaryUrl } from '../../services/cloudinary';

import { CardContainer, ImageContainer, TextContainer } from './CardBlock.styles';
import { Heading3, Heading4 } from '../Text';

interface ICardBlockProps {
  title: string;
  content: string;
  imageSHA: string;
  buttonLabel?: string;
}

export const CardBlock = ({ title, content, imageSHA, buttonLabel }: ICardBlockProps) => {
  return (
    <CardContainer>
      <ImageContainer>
        <img src={getCloudinaryUrl(imageSHA)} alt={title} />
      </ImageContainer>
      <TextContainer>
        <Heading3 data-id="why-origin-heading">{title}</Heading3>
        <Heading4 data-id="why-origin-text">
          <DangerousHtml html={content} />
        </Heading4>
        <Heading4 data-id="why-origin-text-link">{buttonLabel}</Heading4>
      </TextContainer>
    </CardContainer>
  );
};
